import { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  es: {
    dir: "ltr",
    nav: {
      home: "Inicio",
      machines: "Equipos Dermo Faciales",
      technology: "Tecnología",
      sectors: "Sectores",
      cases: "Casos",
      blog: "Blog",
      assistant: "Tú Asistente",
      contact: "Contacto",
      cta_demo: "Solicitar demostración",
    },
    common: {
      learn_more: "Saber más",
      back: "Volver",
      send: "Enviar",
      sending: "Enviando...",
      sent: "Enviado",
      read_article: "Leer artículo",
      loading: "Cargando...",
      contact_us: "Contáctanos",
      view_full: "Ver ficha completa",
      view_tech: "Ver ficha técnica",
      recommended: "Recomendado",
    },
    hero: {
      tagline: "ASIROX · Conscious Engineering · Made in EU",
      title_a: "El Futuro del",
      title_highlight: "Dermo Facial",
      title_b: "Profesional",
      subtitle: "Tecnología de precisión dermo facial diseñada para clínicas médico-estéticas, centros de belleza y franquicias que exigen resultados superiores y rentabilidad real.",
      cta_demo: "Solicitar demostración",
      cta_catalog: "Explorar catálogo",
      cta_quote: "Solicitar presupuesto",
    },
    home: {
      stat_years: "años de ingeniería",
      stat_shots: "disparos garantizados",
      stat_cert: "Certificación médica",
      stat_countries: "países activos",
      sec01: "01 — Catálogo",
      sec01_title_a: "Un equipo por cada",
      sec01_title_highlight: "ambición clínica.",
      sec01_text: "Diseñadas en colaboración con dermatólogos, médicos estéticos y directores de centro. Cada modelo Asirox responde a un perfil de cliente, un volumen y un objetivo de rentabilidad muy específico.",
      sec02: "02 — Conscious Engineering",
      sec02_title_a: "Ingeniería",
      sec02_title_highlight: "consciente,",
      sec02_title_b: "resultados que perduran.",
      sec02_text: "Cada componente de un equipo Asirox responde a una decisión de ingeniería: refrigeración criogénica integrada, ópticas alemanas, electrónica de potencia industrial y software conectado a la nube. Nada accesorio. Nada decorativo.",
      sec03: "03 — Sectores",
      sec03_title: "Donde Asirox marca la diferencia.",
      sec03_view_all: "Ver todos los sectores →",
      sec04: "04 — Casos de éxito",
      sec04_title_a: "Resultados",
      sec04_title_highlight: "medibles",
      sec04_title_b: "en clínicas reales.",
      sec05: "05 — Lo siguiente",
      cta_title_a: "Transforma tu centro con un equipo que",
      cta_title_highlight: "factura por ti.",
      cta_text: "Reserva una demostración técnica con un ingeniero Asirox y recibe un análisis de rentabilidad personalizado para tu modelo de negocio.",
      cta_book: "Reservar demostración",
      cta_ai: "Hablar con Asirox AI",
    },
    footer: {
      tagline: "Belleza atrevida, impulsada por la ciencia. Más de 20 años fabricando aparatología estética premium y equipos profesionales dermo faciales para clínicas, centros estéticos y franquicias de élite en todo el mundo.",
      catalog: "Catálogo",
      company: "Empresa",
      contact: "Contacto",
      address_label: "Sede central",
      copyright: "Belleza atrevida, impulsada por la ciencia.",
    },
  },
  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      machines: "Dermo-Facial Equipment",
      technology: "Technology",
      sectors: "Sectors",
      cases: "Cases",
      blog: "Blog",
      assistant: "Your Assistant",
      contact: "Contact",
      cta_demo: "Request a demo",
    },
    common: {
      learn_more: "Learn more",
      back: "Back",
      send: "Send",
      sending: "Sending...",
      sent: "Sent",
      read_article: "Read article",
      loading: "Loading...",
      contact_us: "Contact us",
      view_full: "View full spec",
      view_tech: "View tech sheet",
      recommended: "Recommended",
    },
    hero: {
      tagline: "ASIROX · Conscious Engineering · Made in EU",
      title_a: "The Future of",
      title_highlight: "Professional Dermo-Facial",
      title_b: "Technology",
      subtitle: "Precision dermo-facial technology designed for medical-aesthetic clinics, beauty centers and franchises that demand superior results and real profitability.",
      cta_demo: "Request a demo",
      cta_catalog: "Explore catalog",
      cta_quote: "Request a quote",
    },
    home: {
      stat_years: "years of engineering",
      stat_shots: "guaranteed shots",
      stat_cert: "Medical certification",
      stat_countries: "active countries",
      sec01: "01 — Catalog",
      sec01_title_a: "A machine for every",
      sec01_title_highlight: "clinical ambition.",
      sec01_text: "Designed in collaboration with dermatologists, aesthetic doctors and clinic directors. Every Asirox model targets a specific customer profile, volume and profitability goal.",
      sec02: "02 — Conscious Engineering",
      sec02_title_a: "Conscious",
      sec02_title_highlight: "engineering,",
      sec02_title_b: "results that last.",
      sec02_text: "Every component of an Asirox machine answers to an engineering decision: integrated cryogenic cooling, German optics, industrial power electronics and cloud-connected software. Nothing accessory. Nothing decorative.",
      sec03: "03 — Sectors",
      sec03_title: "Where Asirox makes the difference.",
      sec03_view_all: "See all sectors →",
      sec04: "04 — Success cases",
      sec04_title_a: "Measurable",
      sec04_title_highlight: "results",
      sec04_title_b: "in real clinics.",
      sec05: "05 — What's next",
      cta_title_a: "Transform your center with a machine that",
      cta_title_highlight: "earns for you.",
      cta_text: "Book a technical demo with an Asirox engineer and receive a custom profitability analysis for your business model.",
      cta_book: "Book a demo",
      cta_ai: "Talk to Asirox AI",
    },
    footer: {
      tagline: "Daring beauty, driven by science. Over 20 years manufacturing premium aesthetic equipment and professional dermo-facial platforms for elite clinics, beauty centers and franchises worldwide.",
      catalog: "Catalog",
      company: "Company",
      contact: "Contact",
      address_label: "Headquarters",
      copyright: "Daring beauty, driven by science.",
    },
  },
  fr: {
    dir: "ltr",
    nav: {
      home: "Accueil",
      machines: "Équipements Dermo-Faciaux",
      technology: "Technologie",
      sectors: "Secteurs",
      cases: "Études de cas",
      blog: "Blog",
      assistant: "Votre Assistant",
      contact: "Contact",
      cta_demo: "Demander une démo",
    },
    common: {
      learn_more: "En savoir plus",
      back: "Retour",
      send: "Envoyer",
      sending: "Envoi...",
      sent: "Envoyé",
      read_article: "Lire l'article",
      loading: "Chargement...",
      contact_us: "Nous contacter",
      view_full: "Voir la fiche complète",
      view_tech: "Voir la fiche technique",
      recommended: "Recommandé",
    },
    hero: {
      tagline: "ASIROX · Conscious Engineering · Made in EU",
      title_a: "L'Avenir du",
      title_highlight: "Dermo-Facial",
      title_b: "Professionnel",
      subtitle: "Technologie dermo-faciale de précision conçue pour les cliniques médico-esthétiques, centres de beauté et franchises qui exigent des résultats supérieurs et une rentabilité réelle.",
      cta_demo: "Demander une démo",
      cta_catalog: "Explorer le catalogue",
      cta_quote: "Demander un devis",
    },
    home: {
      stat_years: "années d'ingénierie",
      stat_shots: "tirs garantis",
      stat_cert: "Certification médicale",
      stat_countries: "pays actifs",
      sec01: "01 — Catalogue",
      sec01_title_a: "Une machine pour chaque",
      sec01_title_highlight: "ambition clinique.",
      sec01_text: "Conçues en collaboration avec des dermatologues, des médecins esthétiques et des directeurs de clinique. Chaque modèle Asirox répond à un profil client, un volume et un objectif de rentabilité spécifiques.",
      sec02: "02 — Conscious Engineering",
      sec02_title_a: "Ingénierie",
      sec02_title_highlight: "consciente,",
      sec02_title_b: "résultats qui durent.",
      sec02_text: "Chaque composant d'une machine Asirox répond à une décision d'ingénierie : refroidissement cryogénique intégré, optique allemande, électronique industrielle de puissance et logiciel connecté au cloud. Rien d'accessoire. Rien de décoratif.",
      sec03: "03 — Secteurs",
      sec03_title: "Là où Asirox fait la différence.",
      sec03_view_all: "Voir tous les secteurs →",
      sec04: "04 — Cas de succès",
      sec04_title_a: "Résultats",
      sec04_title_highlight: "mesurables",
      sec04_title_b: "dans des cliniques réelles.",
      sec05: "05 — La suite",
      cta_title_a: "Transformez votre centre avec une machine qui",
      cta_title_highlight: "facture pour vous.",
      cta_text: "Réservez une démo technique avec un ingénieur Asirox et recevez une analyse de rentabilité personnalisée pour votre modèle commercial.",
      cta_book: "Réserver une démo",
      cta_ai: "Parler à Asirox AI",
    },
    footer: {
      tagline: "Beauté audacieuse, portée par la science. Plus de 20 ans à fabriquer des équipements esthétiques premium et des plateformes dermo-faciales professionnelles pour cliniques, centres et franchises d'élite dans le monde entier.",
      catalog: "Catalogue",
      company: "Entreprise",
      contact: "Contact",
      address_label: "Siège",
      copyright: "Beauté audacieuse, portée par la science.",
    },
  },
};

export const LANGUAGES = [
  { code: "es", label: "ES", name: "Castellano" },
  { code: "en", label: "EN", name: "English" },
  { code: "fr", label: "FR", name: "Français" },
];

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    const saved = localStorage.getItem("asirox_lang");
    // Migrate any previously-stored unsupported lang (e.g. "ar") back to default
    if (saved && STRINGS[saved]) return saved;
    return "es";
  });

  useEffect(() => {
    localStorage.setItem("asirox_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = STRINGS[lang].dir;
  }, [lang]);

  const t = (path) => {
    const keys = path.split(".");
    let cur = STRINGS[lang] || STRINGS.es;
    for (const k of keys) cur = cur?.[k];
    if (cur == null) {
      // fallback to ES
      let fb = STRINGS.es;
      for (const k of keys) fb = fb?.[k];
      return fb ?? path;
    }
    return cur;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dir: STRINGS[lang].dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
}
